import React from 'react';
import { COLORS } from '../../utils/constants';

const QuestJourney = () => {
  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
      padding: '10px'
    }}>
      <style>{`
        @keyframes slideDown {
          0% { transform: translateY(-60px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
        }
        @keyframes drawPath {
          0% { stroke-dashoffset: 100; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes iconPop {
          0% { transform: scale(0); }
          50% { transform: scale(1.15); }
          100% { transform: scale(1); }
        }
        .quest-1 { animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both; }
        .quest-2 { animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.5s both; }
        .quest-3 { animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s both; }
        .float-1 { animation: float 3.5s ease-in-out infinite; }
        .float-2 { animation: float 3.5s ease-in-out 1s infinite; }
        .float-3 { animation: float 3.5s ease-in-out 2s infinite; }
        .icon-1 { animation: iconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.5s both; }
        .icon-2 { animation: iconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.8s both; }
        .icon-3 { animation: iconPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 1.1s both; }
      `}</style>

      <svg width="500" height="600" viewBox="0 0 600 800" style={{ maxWidth: '100%', height: 'auto' }}>
        <defs>
          <linearGradient id="cardGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{stopColor: '#ffffff', stopOpacity: 1}}/>
            <stop offset="100%" style={{stopColor: '#f8fafb', stopOpacity: 1}}/>
          </linearGradient>
          <filter id="cardShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="8"/>
            <feOffset dx="0" dy="4" result="offsetblur"/>
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.15"/>
            </feComponentTransfer>
            <feMerge>
              <feMergeNode/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* Connecting dotted path */}
        <g opacity="0.4">
          <path 
            d="M 220 260 Q 300 310 260 380" 
            stroke="#6B7280" 
            strokeWidth="3" 
            strokeDasharray="8,8" 
            fill="none"
            strokeLinecap="round"
          >
            <animate attributeName="stroke-dashoffset" from="100" to="0" dur="2s" begin="0.3s" fill="freeze"/>
          </path>
          <path 
            d="M 340 440 Q 380 490 340 570" 
            stroke="#6B7280" 
            strokeWidth="3" 
            strokeDasharray="8,8" 
            fill="none"
            strokeLinecap="round"
          >
            <animate attributeName="stroke-dashoffset" from="100" to="0" dur="2s" begin="0.6s" fill="freeze"/>
          </path>
        </g>

        {/* Quest 1 - Warm-up Questions */}
        <g className="quest-1 float-1">
          <rect x="80" y="180" width="280" height="140" rx="24" fill="url(#cardGrad)" filter="url(#cardShadow)"/>
          <rect x="80" y="180" width="280" height="140" rx="24" fill="#E0F7F4" opacity="0.6"/>
          
          <circle cx="130" cy="200" r="32" fill="#3B82F6" className="icon-1" filter="url(#cardShadow)"/>
          <path 
            d="M 120 200 L 127 207 L 140 192" 
            stroke="white" 
            strokeWidth="4" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            fill="none"
            className="icon-1"
          />
          
          <text x="220" y="235" textAnchor="middle" fill="#1F2937" fontSize="32" fontWeight="800">
            Quest 1
          </text>
          <text x="220" y="270" textAnchor="middle" fill="#4B5563" fontSize="20" fontWeight="600">
            Warm-up
          </text>
          <text x="220" y="295" textAnchor="middle" fill="#4B5563" fontSize="20" fontWeight="600">
            Questions
          </text>
        </g>

        {/* Quest 2 - Exploration */}
        <g className="quest-2 float-2">
          <rect x="240" y="360" width="280" height="140" rx="24" fill="url(#cardGrad)" filter="url(#cardShadow)"/>
          <rect x="240" y="360" width="280" height="140" rx="24" fill="#D1FAE5" opacity="0.6"/>
          
          <circle cx="290" cy="380" r="32" fill="#10B981" className="icon-2" filter="url(#cardShadow)"/>
          <rect x="280" y="372" width="20" height="16" rx="3" fill="white" className="icon-2"/>
          <rect x="285" y="368" width="10" height="6" rx="1" fill="white" className="icon-2"/>
          
          <text x="380" y="415" textAnchor="middle" fill="#1F2937" fontSize="32" fontWeight="800">
            Quest 2
          </text>
          <text x="380" y="460" textAnchor="middle" fill="#4B5563" fontSize="20" fontWeight="600">
            Exploration
          </text>
        </g>

        {/* Quest 3 - Deep Dive */}
        <g className="quest-3 float-3">
          <rect x="120" y="540" width="280" height="140" rx="24" fill="url(#cardGrad)" filter="url(#cardShadow)"/>
          <rect x="120" y="540" width="280" height="140" rx="24" fill="#FEF3C7" opacity="0.6"/>
          
          <circle cx="170" cy="560" r="32" fill="#F59E0B" className="icon-3" filter="url(#cardShadow)"/>
          <path 
            d="M 170 545 L 175 555 L 185 557 L 177.5 564 L 180 574 L 170 569 L 160 574 L 162.5 564 L 155 557 L 165 555 Z" 
            fill="white"
            className="icon-3"
          />
          
          <text x="260" y="595" textAnchor="middle" fill="#1F2937" fontSize="32" fontWeight="800">
            Quest 3
          </text>
          <text x="260" y="640" textAnchor="middle" fill="#4B5563" fontSize="20" fontWeight="600">
            Deep Dive
          </text>
        </g>

        {/* Decorative dots */}
        {[
          {x: 60, y: 300},
          {x: 540, y: 250},
          {x: 80, y: 500},
          {x: 520, y: 600}
        ].map((dot, i) => (
          <circle key={i} cx={dot.x} cy={dot.y} r="4" fill="#6B7280" opacity="0.4">
            <animate 
              attributeName="cy" 
              values={`${dot.y};${dot.y - 40};${dot.y}`} 
              dur="4s" 
              begin={`${i * 0.5}s`}
              repeatCount="indefinite"
            />
            <animate 
              attributeName="opacity" 
              values="0.4;0;0.4" 
              dur="4s" 
              begin={`${i * 0.5}s`}
              repeatCount="indefinite"
            />
          </circle>
        ))}

        {/* Bottom tagline */}
        <text x="300" y="750" textAnchor="middle" fill="#4B5563" fontSize="18" fontWeight="700" opacity="0.9">
          Turn boring forms into gamified quests!
        </text>
      </svg>
    </div>
  );
};

export default QuestJourney;